import { BellIcon } from "@heroicons/react/24/outline";
import { SidebarItem, SidebarLabel, SidebarMode } from "components/layout/sidebar";
import { Badge } from "components/ui/badge";
import { ReminderContext } from "contexts/reminder";
import React, { useCallback, useContext } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { hideMenu } from "store/actions/responsive";

interface ReminderSidebarItemProps {
    mode: SidebarMode;
}

export const ReminderSidebarItem: React.FC<ReminderSidebarItemProps> = ({ mode }) => {
    const dispatch = useDispatch();
    const { isReminderEnabled, setVisible, reminders } = useContext(ReminderContext);
    const remindersCount = reminders?.length || 0;

    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            setVisible(true);
            dispatch(hideMenu());
        },
        [setVisible, dispatch],
    );

    if (!isReminderEnabled) {
        return null;
    }

    if (mode === "icons") {
        return (
            <Link
                to="#"
                onClick={handleClick}
                className="relative p-2 rounded-lg text-brand-800 hover:bg-zinc-950/5 dark:text-brand-400 dark:hover:bg-brand-950/30"
                title="Reminders">
                <BellIcon className="size-5" />
                {remindersCount > 0 && (
                    <span className="absolute top-0.5 right-0.5 flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                    </span>
                )}
            </Link>
        );
    }

    return (
        <SidebarItem current={false} onClick={handleClick}>
            <BellIcon className="w-5 h-5" />
            <SidebarLabel className="flex-1">
                <div className="flex justify-between items-center w-full">
                    <div>Reminders</div>
                    {remindersCount > 0 ? (
                        <Badge value={remindersCount.toString()} type="error" />
                    ) : null}
                </div>
            </SidebarLabel>
        </SidebarItem>
    );
};
